const styles = {
  picker: {
    width: "100%",
    margin: "2rem auto"
  },
  addColor: {
    width: "100%",
    padding: "0.5rem",
    marginTop: "1rem",
    fontSize: "1.5rem",
  },
  colorNameInput: {
    width: "100%",
    height: "70px"
  }
};

export default styles;